module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Table of Contents")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/Text/Frontmatter01#frontmatter01"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Part01#part01"
    }
  }, [_vm._v("PART I: OVER VIEW")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Chapter01#chapter01"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter02"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Chapter02#chapter02"
    }
  }, [_vm._v("ABOUT THE BOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter03"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Chapter03#chapter03"
    }
  }, [_vm._v("WHY WE LOVE MUSCLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OUR APPROACH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter05#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FREQUENTLY ASKED QUESTIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: THE PROGRAMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter06#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEFORE YOU BEGIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter07#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 WEEKS TO 10 POUNDS OF MUSCLE PROGRAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter08#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PREP PROGRAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter09"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter09#chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTERMEDIATE PROGRAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADVANCED PROGRAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REFLECTIONS ON THE PROGRAMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: THE NUTRITION PROGRAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EAT MORE, GAIN MORE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EATING TO GROW MUSCLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BASIC NUTRITION PRINCIPLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SCIENCE BEHIND IT ALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter16"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter16#chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE 7-WEEK MUSCLE-BUILDING NUTRITION PLAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: THE KITCHEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter17"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter17#chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT TO EAT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter18"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter18#chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SAMPLE 3-DAY MUSCLE-BUILDING MEAL PLAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter19"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter19#chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COOK YOUR WAY TO BIG MUSCLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart05"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/Part05#part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V: EXERCISES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter20"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter20#chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LIFTING BASICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter21"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter20a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXERCISES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter22"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter22#chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEXT STEPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Backmatter01#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rbackmatter01section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Backmatter01section01#backmatter01section01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WARMING UP & STRETCHING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Backmatter02#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Backmatter03#backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHOTO CREDITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Backmatter04#backmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Backmatter05#backmatter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHORS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed6dac92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 66
// module chunks = 0